import { render } from "./body.calendar.vue?vue&type=template&id=d45c757a&scoped=true"
import script from "./body.calendar.vue?vue&type=script&lang=js"
export * from "./body.calendar.vue?vue&type=script&lang=js"

import "./body.calendar.vue?vue&type=style&index=0&id=d45c757a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d45c757a"]])

export default __exports__